import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDbcqjDQ4dj8FW9CULUJLksAmVMM7UOkws",
  authDomain: "smart-task-manager-3bf4a.firebaseapp.com",
  projectId: "smart-task-manager-3bf4a",
  storageBucket: "smart-task-manager-3bf4a.firebasestorage.app",
  messagingSenderId: "1004144032354",
  appId: "1:1004144032354:web:228f4d989479363c32af3b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;